/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Point_3Inputs */

const en_services_svc_agents_point_3 = /** @type {(inputs: Services_Svc_Agents_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-off points and a record of every hand-off`)
};

const lv_services_svc_agents_point_3 = /** @type {(inputs: Services_Svc_Agents_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināšanas punkti un katras nodošanas pieraksts`)
};

/**
* | output |
* | --- |
* | "Sign-off points and a record of every hand-off" |
*
* @param {Services_Svc_Agents_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_point_3 = /** @type {((inputs?: Services_Svc_Agents_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_point_3(inputs)
	return en_services_svc_agents_point_3(inputs)
});